import React, { useEffect, useState } from "react";
import {
  ApartmentOutlined,
  BranchesOutlined,
  CreditCardOutlined,
  HistoryOutlined,
  LineChartOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PaperClipOutlined,
  PayCircleOutlined,
  UserSwitchOutlined,
  ZoomInOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu, theme } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import Profile from "../components/other/profile";
import MerchantHelper from "../components/other/merchantHelper";
import { bg_text } from "constant/css";
import { useMerchant } from "context/merchantContext";

const { Header, Content, Sider } = Layout;

const MerchantLayout = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { permissions } = useMerchant();
  const [protectedItems, setProtectedItems] = useState([]);
  const [selected, setSelected] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const selectedKeys = selected ? [selected.key] : [];
  const navigate = useNavigate();
  const isImpersonation = sessionStorage.getItem("isImpersonation") === "true";
  const rawData =
    sessionStorage.getItem("merchantData") ||
    localStorage.getItem("merchantData");
  const merchantData = rawData ? JSON.parse(rawData) : {};

  const items = [
    {
      iconf: (props) => <LineChartOutlined {...props} />,
      icon: <LineChartOutlined />,
      key: "merchantDashboard",
      label: "Хянах самбар",
      permissions: null,
    },
    {
      iconf: (props) => <CreditCardOutlined {...props} />,
      icon: <CreditCardOutlined />,
      key: "merchantInvoiceList",
      label: "Гүйлгээ",
      permissions: null,
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <UserSwitchOutlined />,
      key: "merchantVat",
      label: "Дэд мерчант",
      permissions: [4],
    },
    {
      iconf: (props) => <HistoryOutlined {...props} />,
      icon: <HistoryOutlined />,
      key: "vatLog",
      label: "НӨАТ Түүх (паркли)",
      permissions: [4],
    },
    {
      iconf: (props) => <CreditCardOutlined {...props} />,
      icon: (
        <img
          src="/smartbilling.png"
          className="rounded-xl"
          width={30}
          style={{ marginLeft: -10 }}
          height={30}
        />
      ),
      key: "xpayPayment",
      label: "Хэтэвч",
      permissions: [1],
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <UserSwitchOutlined />,
      key: "merchantIncome",
      label: "Орлого",
      permissions: [2, 3],
    },
    {
      iconf: (props) => <UserSwitchOutlined {...props} />,
      icon: <UserSwitchOutlined />,
      key: "subMerchantIncome",
      label: "Дэд мерчант орлого",
      permissions: [2, 3],
    },
    {
      iconf: (props) => <ZoomInOutlined {...props} />,
      icon: <ZoomInOutlined />,
      key: "xpayDoc",
      label: "Таньд зориулав",
      permissions: null,
    },
    {
      iconf: (props) => <ApartmentOutlined {...props} />,
      icon: <ApartmentOutlined />,
      key: "merchantFeeShareRule",
      label: "Тооцоо хуваарилалт",
      permissions: null,
    },
    {
      iconf: (props) => <BranchesOutlined {...props} />,
      icon: <BranchesOutlined />,
      key: "merchantSplitHistory",
      label: "Хуваарилалтын түүх",
      permissions: null,
    },
    {
      iconf: (props) => <HistoryOutlined {...props} />,
      icon: <HistoryOutlined />,
      key: "merchantActionLog",
      label: "Үйлдлийн түүх",
      permissions: null,
    },
  ];

  useEffect(() => {
    const currentPath = window.location.pathname.split("/").pop();
    const findItemByKey = (key, list) => {
      for (const item of list) {
        if (item.key === key) return item;
        if (item.children) {
          const found = findItemByKey(key, item.children);
          if (found) return found;
        }
      }
      return null;
    };
    const currentItem = findItemByKey(currentPath, items);
    if (currentItem) setSelected(currentItem);
  }, []);

  useEffect(() => {
    const filteredItems = items.filter((item) => {
      if (!item.permissions) return true;
      return item.permissions.some((perm) => permissions.includes(perm));
    });
    if (filteredItems.length > 0) setSelected(filteredItems[0]);
    setProtectedItems(filteredItems);
  }, [permissions]);

  const setAndNavigate = (e) => {
    const findItem = (key, list) => {
      for (const item of list) {
        if (item.key === key) return item;
        if (item.children) {
          const found = findItem(key, item.children);
          if (found) return found;
        }
      }
      return null;
    };
    const item = findItem(e.key, items);
    setSelected(item);
    navigate(e.key);
    if (isMobile) setCollapsed(true);
  };

  const siderWidth = 220;
  const collapsedWidth = isMobile ? 0 : 64;

  return (
    <Layout style={{ height: "100vh" }} hasSider>
      {/* Mobile overlay */}
      {isMobile && !collapsed && (
        <div
          onClick={() => setCollapsed(true)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 998,
          }}
        />
      )}

      <Sider
        width={siderWidth}
        collapsible
        collapsed={collapsed}
        collapsedWidth={collapsedWidth}
        onCollapse={setCollapsed}
        breakpoint="lg"
        onBreakpoint={(broken) => {
          setIsMobile(broken);
          setCollapsed(broken);
        }}
        trigger={null}
        style={{
          background: colorBgContainer,
          overflow: "auto",
          height: "100vh",
          scrollbarWidth: "thin",
          scrollbarGutter: "stable",
          position: isMobile ? "fixed" : "sticky",
          insetInlineStart: 0,
          top: 0,
          bottom: 0,
          zIndex: isMobile ? 999 : 1,
          boxShadow:
            isMobile && !collapsed ? "2px 0 8px rgba(0,0,0,0.18)" : "none",
          transition: "all 0.2s",
        }}
        className="sider"
      >
        {/* Logo */}
        <div
          style={{
            padding: collapsed ? "16px 8px" : "16px 20px",
            display: "flex",
            flexDirection: "column",
            alignItems: collapsed ? "center" : "flex-start",
            overflow: "hidden",
            minHeight: 72,
            justifyContent: "center",
            transition: "padding 0.2s",
          }}
        >
          {collapsed ? (
            <img
              src="/smartbilling.png"
              width={32}
              height={32}
              className="rounded-xl"
              style={{ flexShrink: 0 }}
            />
          ) : (
            <>
              <span
                className={`${bg_text} font-black`}
                style={{ fontSize: 16, whiteSpace: "nowrap" }}
              >
                Смарт Биллинг
              </span>
              <span
                className={`${bg_text}`}
                style={{ fontSize: 11, whiteSpace: "nowrap", opacity: 0.7 }}
              >
                Rapid, Reliable, Rewarding
              </span>
            </>
          )}
        </div>

        <Menu
          theme="light"
          mode="inline"
          selectedKeys={selectedKeys}
          onClick={setAndNavigate}
          items={protectedItems}
          style={{ borderInlineEnd: "none" }}
        />

        {!collapsed && <Profile />}
      </Sider>

      <Layout
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: isMobile ? 0 : undefined,
        }}
      >
        {isImpersonation && (
          <div
            style={{
              background: "#faad14",
              color: "#000",
              textAlign: "center",
              padding: "4px 16px",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            Админ горим: <strong>{merchantData?.name}</strong> мерчантын эрхээр
            нэвтэрч байна
          </div>
        )}
        <Header
          style={{
            background: colorBgContainer,
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
            height: 56,
            justifyContent: "space-between",
            borderBottom: "1px solid #f0f0f0",
            position: "sticky",
            top: 0,
            zIndex: 100,
            gap: 8,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            <Button
              type="text"
              icon={
                collapsed ? (
                  <MenuUnfoldOutlined style={{ fontSize: 18 }} />
                ) : (
                  <MenuFoldOutlined style={{ fontSize: 18 }} />
                )
              }
              onClick={() => setCollapsed(!collapsed)}
              style={{ flexShrink: 0 }}
            />
            {selected && (
              <>
                {selected.iconf({ style: { fontSize: 22, color: "#66baa8", flexShrink: 0 } })}
                <h2
                  className={`${bg_text} font-bold`}
                  style={{
                    fontSize: 16,
                    margin: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {selected.label}
                </h2>
              </>
            )}
          </div>
        </Header>

        <div
          className="absolute bottom-10 right-10"
          style={{ zIndex: 999 }}
        >
          <MerchantHelper />
        </div>

        <Content
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "5px 12px",
            background: colorBgContainer,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MerchantLayout;
